import React from 'react';
import { Breadcrumb, BreadcrumbWrapper } from '@components/breadcrumb/styled.tsx';
import type { BreadcrumbProps as BaseBreadcrumbProps } from 'antd';

export type { BaseBreadcrumbProps };

export const BaseBreadcrumb: React.FC<BaseBreadcrumbProps> = ({ className, ...props }) => (
    <BreadcrumbWrapper>
        <Breadcrumb className={className} {...props} />
    </BreadcrumbWrapper>
);
